import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const GaIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <g fillRule="evenodd">
      <path fill="#ffe700" d="M640 480H0V0h640z" />
      <path fill="#36a100" d="M640 160H0V0h640z" />
      <path fill="#006dbc" d="M640 480H0V320h640z" />
    </g>
  </ChakraIcon>
);
